// extracted by mini-css-extract-plugin
export default {"header":"SalesregHeader_header__Sp-47","syncBtn":"SalesregHeader_syncBtn__WW9YW","rightSection":"SalesregHeader_rightSection__vEs2a"};